module.exports = __webpack_public_path__ + "static/img/m5.c4cf3b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m5.png
// module id = L+zF
// module chunks = 12